export const styleDivider = {
    width: '100%',
    margin: '5px 0px 5px 0px',
    borderTop: '1px solid #c4c4c4'
}

export const styleRowInput = {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    padding: '5px',
    alignItems: 'center',
    justifyContent: 'space-between'
}

export const styleLabelInput = {
    marginRight: '10px',
    fontSize: '14px',
    color: '#000',
    width: '12.5%'
}

export const styleLargeRow = {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    padding: '5px'
}

export const styleRowDate = {
    display: 'flex',
    justifyContent: 'space-between'
}

export const styleDivDate = {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    alignItems: 'center',
    width: '49%'
}

export const styleLabelDate = {
    marginRight: '10px',
    fontSize: '14px',
    color: '#000',
    width: '30%'
}

export const styleActionButtons = {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    marginTop: '5px',
    justifyContent: 'flex-end'
}

export const styleStandartButton = {
    border: '0px',
    backgroundColor: '#a8a4ab',
    '&:hover': {
        backgroundColor: '#535353'
    }
}

export const styleLinearLoading = {
    width: '100%',
    height: '1px',
    margin: '5px 0px 5px 0px'
}

export const styleHeaderAutoReply = {
    marginRight: '10px',
    fontSize: '14px',
    color: '#000'
}

export const styleDivSchedule = {
    width: '75%',
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    alignItems: 'center'
}

export const stylePeriod = {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    padding: '5px',
    alignItems: 'center'
}

export const styleButtonConfirm = {
    border: '0px',
    backgroundColor: '#9b59b6',
    '&:hover': {
        backgroundColor: '#8e44ad'
    }
}

export const styleSelectReport = {
    padding: '5px',
    display: 'flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center'
}

export const styleLabelSelectReport = {
    fontWeight: 500,
    color: '#000',
    fontSize: '14px'
}

export const styleLoading = {
    padding: '5px',
    display: 'flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10
}

export const styleRelatoriosConfig = {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    gap: 10
}

export const styleRelatorioWidth = {
    width: '50%'
}

export const styleRelatoriosConfigWeight = {
    fontWeight: 500,
    padding: 5
}

export const styleRelatorioConfigHeader = {
    height: '3%'
}

export const styleRelatoriosConfigDivider = {
    color: '#000',
    width: '100%',
    borderTop: '1px solid #c4c4c4'
}

export const styleRelatorios = {
    height: '85vh',
    maxHeight: '95%',
    minHeight: '50vh',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    backgroundColor: '#D9D9D9',
    borderRadius: '5px',
    padding: '10px',
    paddingBottom: '20px',
    gap: '5px',
    boxSizing: 'border-box'
}

export const styleOpcoesRelatoriosHover = {
    padding: '5px',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: '#be00ff2b',
    borderRadius: '5px',
    cursor: 'pointer',
    gap: '10px',
    border: '1px solid #9500c8',
    userSelect: 'none'
}

export const styleOpcoesRelatorios = {
    padding: '5px',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    borderRadius: '5px',
    gap: '10px',
    border: '1px solid #fff',
    userSelect: 'none'
}

export const styleSelectedOrHoveredButton = {
    border: '1px solid #9500c8',
    backgroundColor: '#be00ff2b',
    color: '#000'
}

export const styleNormalStateButton = {
    border: '1px solid #fff',
    backgroundColor: '#FFF',
    color: '#000'
}

export const styleRelatoriosConfigTitulo = {
    fontWeight: 600,
    color: '#000',
    paddingLeft: '5px'
}

export const styleRelatoriosConfigDescricao = {
    fontWeight: 300,
    color: '#000',
    fontSize: '14px',
    paddingLeft: '5px'
}
